import { render, staticRenderFns } from "./modal-risco.vue?vue&type=template&id=f24a9b00&scoped=true"
import script from "./modal-risco.vue?vue&type=script&lang=js"
export * from "./modal-risco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24a9b00",
  null
  
)

export default component.exports